export class AlfatronSck51 {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.videoInput = '1';
        this.audioChannels = {};
        this.videoRouting = {};
        this.multiview = '1'; // Default to 'single'
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /s\s+autoswitch\s+(\d+)!/i,
                callback: (match) => {
                    this.socket.send(`@autoswitch ${match[1]}`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /q\s*fw\s*version!/i,
                callback: (match) => {
                    this.socket.send('MCU 1.00');
                },
            },
            {
                name: 'faderGet',
                regExp: /q\s+(inp|outp)\s+(\d+)\s+audio\s*vol!/i,
                callback: (match) => {
                    var _a, _b;
                    const key = `${match[1]}.${match[2]}`;
                    const volume = (_b = (_a = this.audioChannels[key]) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : 0;
                    this.socket.send(`@${match[1]} audio ${match[2]}, vol${volume}`);
                },
            },
            {
                name: 'faderSet',
                regExp: /s\s+(inp|outp)\s+(\d+)\s+audio\s*vol\s+(\d+)!/i,
                callback: (match) => {
                    const key = `${match[1]}.${match[2]}`;
                    const volume = parseInt(match[3], 10);
                    this.audioChannels[key].volume = volume;
                    this.socket.send(`@${match[1]} audio ${match[2]}, vol${volume}`);
                },
            },
            {
                name: 'muteGet',
                regExp: /q\s+(inp|outp)\s+(\d+)\s+audiomute!/i,
                callback: (match) => {
                    const key = `${match[1]}.${match[2]}`;
                    this.socket.send(`@${match[1]} audiomute ${match[2]}, ${this.audioChannels[key].mute ? '1' : '0'}`);
                },
            },
            {
                name: 'muteSet',
                regExp: /s\s+(inp|outp)\s+(\d+)\s+audiomute\s*(0|1)!/i,
                callback: (match) => {
                    const key = `${match[1]}.${match[2]}`;
                    const mute = match[3] === '1';
                    this.audioChannels[key].mute = mute;
                    this.socket.send(`@${match[1]} audiomute ${match[2]}, ${match[3]}`);
                },
            },
            {
                name: 'masterFaderGet',
                regExp: /q\s+master\s+audio\s*vol!/i,
                callback: (match) => {
                    var _a, _b;
                    const key = `master`;
                    const volume = (_b = (_a = this.audioChannels[key]) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : 0;
                    this.socket.send(`@master audio volume ${volume}`);
                },
            },
            {
                name: 'masterFaderSet',
                regExp: /s\s+master\s+audio\s*vol\s+(\d+)!/i,
                callback: (match) => {
                    const key = `master`;
                    const volume = parseInt(match[1], 10);
                    this.audioChannels[key].volume = volume;
                    this.socket.send(`@master audio volume ${volume}`);
                },
            },
            {
                name: 'masterMuteGet',
                regExp: /q\s+master\s+audio\s*mute!/i,
                callback: (match) => {
                    const key = `master`;
                    const mute = this.audioChannels[key].mute;
                    this.socket.send(`@master audio mute ${mute ? '1' : '0'}`);
                },
            },
            {
                name: 'masterMuteSet',
                regExp: /s\s+master\s+audio\s*mute\s+(\d+)!/i,
                callback: (match) => {
                    const key = `master`;
                    const mute = match[1] === '1';
                    this.audioChannels[key].mute = mute;
                    this.socket.send(`@master audio mute ${match[1]}`);
                },
            },
            {
                name: 'getVideoRoute',
                regExp: /q\s+inp\s+source!/i,
                callback: (match) => {
                    this.socket.send(`@inp source ${this.videoInput}`);
                },
            },
            {
                name: 'presetRecall',
                regExp: /s\s+recall\s+ps\s*(\d+)!/i,
                callback: (match) => {
                    this.socket.send(`@recall ps ${match[1]}`);
                },
            },
            {
                name: 'presetName',
                regExp: /q\s+ps\s+(\d+)\sname!/i,
                callback: (match) => {
                    const presetName = `Preset ${match[1]}`;
                    this.socket.send(`@ps ${match[1]} name: ${presetName}`);
                },
            },
            {
                name: 'setVideoRoute',
                regExp: /s\s*inp source\s+(\d+)!/i,
                callback: (match) => {
                    this.videoInput = parseInt(match[1], 10).toString();
                    this.socket.send(`@inp source ${this.videoInput}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /s\s*power\s*(1|0)!/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === '1';
                    this.socket.send(`@power ${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /q\s*power!/i,
                callback: (match) => {
                    this.socket.send(`@power ${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'windowQuery',
                regExp: /q\s+window\s+(\d+)!/i,
                callback: (match) => {
                    const key = `window.${match[1]}`;
                    const value = this.videoRouting[key];
                    this.socket.send(`@window in ${match[1]}, ${value}`);
                },
            },
            {
                name: 'windowSet',
                regExp: /s\s+window\s+(\d+)\s+in\s*(\d+)!/i,
                callback: (match) => {
                    const key = `window.${match[1]}`;
                    const value = parseInt(match[2], 10);
                    this.videoRouting[key] = value;
                    this.socket.send(`@window in ${match[1]}, ${value}`);
                },
            },
            {
                name: 'multiviewQuery',
                regExp: /q\s+multiview!/i,
                callback: (match) => {
                    this.socket.send(`@multiview ${this.multiview}`);
                },
            },
            {
                name: 'multiviewSet',
                regExp: /s\s+multiview\s*(\d+)!/i,
                callback: (match) => {
                    this.multiview = match[1];
                    this.socket.send(`@multiview ${this.multiview}`);
                },
            },
        ];
        for (let i = 0; i < 4; i++) {
            this.audioChannels[`inp.${i}`] = { mute: false, volume: 50 };
            this.audioChannels[`outp.${i}`] = { mute: false, volume: 50 };
        }
        this.audioChannels[`master`] = { mute: false, volume: 50 };
        // Add window "routing" as unmuted = routed
        for (let win = 0; win <= 4; win++) {
            for (let chan = 1; chan <= 5; chan++) {
                if (chan === win) {
                    // Default routing
                    this.videoRouting[`window.${win}`] = chan;
                }
                else {
                    this.videoRouting[`window.${win}`] = 1;
                }
            }
        }
    }
}
AlfatronSck51.emulatorType = 'socketEmulator';
AlfatronSck51.key = '-OJsAOoSgSahwm92bP9t';
